import React, { useRef, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import fonts from '@general/fonts';
import colors from '@general/colors';

export const CurrentRecipientStyled = styled.div`
    font-family: ${fonts.sans};
    margin-top: 10px;
    padding: 13px 32px;
    border: 1px solid ${colors.lightGray};
    font-size: 1.1rem;
    height: 54px;
`;

export const ConversationWindowStyled = styled.div`
    padding: 38px;
    padding-bottom: 0;
    border: 1px solid #d8d8d8;
    box-sizing: border-box;
    box-shadow: inset 0px 2px 8px rgba(87, 87, 87, 0.25);
    margin-top: 26px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column-reverse;
    overflow: auto;
    height: 400px;
`;

export const ConversationContainer = styled.div``;

export const MessagesContainerStyled = styled.div`
    margin-bottom: 20px;
`;

export const MessagesFromContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MessageFromStyled = styled.div`
    padding: 0.7rem 1rem;
    background-color: ${colors.azure};
    color: ${colors.white};
    margin-bottom: 0.4rem;
    font-family: ${fonts.sans};
    font-size: 0.9rem;
    border-radius: 0px 8px 8px 8px;
    align-self: flex-start;
`;

export const MessagesToContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MessageToStyled = styled.div`
    padding: 0.7rem 1rem;
    background-color: ${colors.lightGray};
    color: ${colors.black};
    margin-bottom: 0.4rem;
    font-family: ${fonts.sans};
    font-size: 0.9rem;
    border-radius: 8px 0px 8px 8px;
    align-self: flex-end;
    text-align: right;
    max-width: 90%;
`;

export const TimeStyled = styled.div`
    font-family: ${fonts.sans};
    font-size: 0.8rem;
    color: ${colors.darkGray};
    margin-bottom: 1rem;
`;
